import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelDynamic as _vModelDynamic, withKeys as _withKeys } from "vue"

const _hoisted_1 = { id: "outerContainer" }
const _hoisted_2 = { id: "mainContainer" }
const _hoisted_3 = {
  key: 1,
  class: "pdf-footer"
}
const _hoisted_4 = { class: "sidebar-content" }
const _hoisted_5 = ["onClick", "title"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "text-file" }
const _hoisted_8 = {
  key: 1,
  class: "text-size"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "sidebar-header" }
const _hoisted_11 = {
  key: 1,
  class: "txt-loading"
}
const _hoisted_12 = { class: "txt-fullname" }
const _hoisted_13 = { class: "txt-ci" }
const _hoisted_14 = { class: "txt-created" }
const _hoisted_15 = {
  key: 3,
  class: "txt-sin-registro"
}
const _hoisted_16 = {
  key: 0,
  class: "txt-loading"
}
const _hoisted_17 = { class: "txt-fullname" }
const _hoisted_18 = { class: "txt-ci" }
const _hoisted_19 = { class: "txt-created" }
const _hoisted_20 = {
  key: 2,
  class: "txt-sin-registro"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 4,
  class: "pdf-modal"
}
const _hoisted_25 = { class: "pdf-modal-content" }
const _hoisted_26 = { class: "container" }
const _hoisted_27 = { class: "pdf-model-subtitle" }
const _hoisted_28 = { class: "pdf-field" }
const _hoisted_29 = { class: "pdf-group-input" }
const _hoisted_30 = ["type"]
const _hoisted_31 = { class: "pdf-model-footer" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 5,
  class: "pdf-modal"
}
const _hoisted_34 = { class: "pdf-modal-content" }
const _hoisted_35 = { class: "container" }
const _hoisted_36 = { class: "pdf-model-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SidebarLeft = _resolveComponent("SidebarLeft")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_ErrorWrapper = _resolveComponent("ErrorWrapper")!
  const _component_OverlayContainer = _resolveComponent("OverlayContainer")!
  const _component_AdsibInformation = _resolveComponent("AdsibInformation")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_EyeSlashIcon = _resolveComponent("EyeSlashIcon")!

  return (_openBlock(), _createElementBlock("div", {
    id: "vuePdfApp",
    class: _normalizeClass([[_ctx.localTheme], "pdf-app"]),
    ref: "pdfRefs"
  }, [
    (
        _ctx.loader.adsib ||
        _ctx.loader.agetic ||
        _ctx.loading ||
        _ctx.loadingAction.login_agetic ||
        _ctx.loadingAction.sync_file
      )
      ? (_openBlock(), _createBlock(_component_LoaderComponent, {
          key: 0,
          message: _ctx.loader.message
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/l10n" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.defaultLocale), 1)
      ]),
      _: 1
    })),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_SidebarLeft, {
            key: 0,
            showElem: _ctx.showElem,
            isToolbarHidden: _ctx.isToolbarHidden,
            isSidebarToolbarHidden: _ctx.isSidebarToolbarHidden,
            slotProps: _ctx.slotProps
          }, null, 8, ["showElem", "isToolbarHidden", "isSidebarToolbarHidden", "slotProps"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Toolbar, {
          showElem: _ctx.showElem,
          onOpenSidebar: _ctx.onOpenSidebar,
          slotProps: _ctx.slotProps,
          viewButton: _ctx.viewButton,
          viewSignature: _ctx.viewSignature,
          valorLegal: _ctx.valorLegal,
          pdfApp: _ctx.pdfApp,
          viewSidebar: _ctx.viewSidebar
        }, null, 8, ["showElem", "onOpenSidebar", "slotProps", "viewButton", "viewSignature", "valorLegal", "pdfApp", "viewSidebar"]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { id: "loadingBar" }, [
          _createElementVNode("div", { class: "progress" }, [
            _createElementVNode("div", { class: "glimmer" })
          ])
        ], -1)),
        _renderSlot(_ctx.$slots, "viewer-header", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _renderSlot(_ctx.$slots, "viewer-prepend", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _createElementVNode("div", {
          id: "viewerContainer",
          class: _normalizeClass([_ctx.isToolbarHidden]),
          tabindex: "0"
        }, _cache[15] || (_cache[15] = [
          _createElementVNode("div", {
            id: "viewer",
            class: "pdfViewer"
          }, null, -1)
        ]), 2),
        _renderSlot(_ctx.$slots, "viewer-append", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _renderSlot(_ctx.$slots, "viewer-footer", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
        _createVNode(_component_ErrorWrapper, { showElem: _ctx.showElem }, null, 8, ["showElem"])
      ], 512), [
        [_vShow, !_ctx.loading]
      ]),
      _createVNode(_component_OverlayContainer)
    ]),
    (_ctx.footerVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.footerText), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "loader", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true),
    (!_ctx.loading && _ctx.viewSidebar.files)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({
        hidden: !_ctx.viewSidebar.files,
        'sidebar-files-custom': _ctx.viewSidebar.files,
      })
        }, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "sidebar-header" }, "Archivos", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesInformation, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "button-content",
                key: index
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.onSelectFile(item)),
                  class: _normalizeClass(["button-file", {
              'button-file-select': item.id == _ctx.viewSidebar.fileSelect?.id,
            }]),
                  title: 
              _ctx.enableInformationFile
                ? `Firmas: ${item.totalFirmadosAdsib}\nAprobadas: ${item.totalFirmadosAgetic}`
                : undefined
            
                }, [
                  (_ctx.buttonSyncFile && item.id == _ctx.viewSidebar.fileSelect?.id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["rotateCcw vue-pdf-app-icon rotate-counter-clockwise btn-sync-loading", {
                'btn-rotate': _ctx.loadingAction.sync_file,
                'btn-disabled': item.id != _ctx.viewSidebar.fileSelect?.id,
              }]),
                        title: "Sincronizar Archivo",
                        disabled: item.id != _ctx.viewSidebar.fileSelect?.id,
                        onClick: _cache[0] || (_cache[0] = () => (_ctx.modalSync = true))
                      }, null, 10, _hoisted_6))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.fileName), 1),
                  (item?.size)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(_ctx.formatSizeUnits(item.size)) + ") ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.buttonDeleteFile || _ctx.files.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "button-close",
                        title: "Eliminar",
                        onClick: ($event: any) => (_ctx.onDeleteFile(item.id))
                      }, " × ", 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5)
              ]))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.viewSidebar.signatures)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass({
        hidden: !_ctx.viewSidebar.signatures,
        'sidebar-signatures-custom': _ctx.viewSidebar.signatures,
      })
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["rotateCcw vue-pdf-app-icon rotate-counter-clockwise btn-loading", {
            'btn-rotate': _ctx.data_items.adsibLoading || _ctx.data_items.ageticLoading,
          }]),
              title: "Recargar",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLoadSignatarios && _ctx.onLoadSignatarios(...args)))
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.valorLegal.adsib ? "ADSIB" : _ctx.valorLegal.agetic ? "AGETIC" : ""), 1)
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "sidebar-divider" }, null, -1)),
          (_ctx.valorLegal.adsib)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sidebar-content",
                style: _normalizeStyle({
          height: _ctx.signature.adsib ? (_ctx.footerVisible ? '85%' : '88%') : '95%',
        })
              }, [
                (_ctx.adsibInformation)
                  ? (_openBlock(), _createBlock(_component_AdsibInformation, {
                      key: 0,
                      adsibInformation: _ctx.adsibInformation
                    }, null, 8, ["adsibInformation"]))
                  : _createCommentVNode("", true),
                (_ctx.data_items.adsibLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Cargando... "))
                  : (_ctx.items.adsib.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.items.adsib.reverse(), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "card-sign"
                        }, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.certificado.nombreSignatario), 1),
                          _createElementVNode("div", _hoisted_13, " CI: " + _toDisplayString(item.certificado.ci.substring(0, item.certificado.ci.length - 1)), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.DateTime.fromISO(item.fechaFirma).toFormat(_ctx.DATE_TIME_FULL_HUMAN)), 1)
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[18] || (_cache[18] = [
                        _createTextVNode(" SIN REGISTRO "),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" DE "),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" SIGNATARIOS ")
                      ])))
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.valorLegal.agetic)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "sidebar-content",
                style: _normalizeStyle({
          height: _ctx.signature.agetic ? (_ctx.footerVisible ? '85%' : '88%') : '95%',
        })
              }, [
                (_ctx.data_items.ageticLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Cargando... "))
                  : ((_ctx.aprobadores??[])?.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.aprobadores??[].reverse(), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "card-sign"
                        }, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.nombres) + " " + _toDisplayString(item.primer_apellido) + " " + _toDisplayString(item.segundo_apellido), 1),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.ci), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.fechaSolicitud
                  .substring(0, item.fechaSolicitud.length - 4)
                  .replaceAll("/", "-")), 1)
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[19] || (_cache[19] = [
                        _createTextVNode(" SIN REGISTRO "),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" DE"),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" SIGNATARIOS ")
                      ])))
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.valorLegal.adsib && _ctx.signature.adsib)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "sidebar-footer",
                style: _normalizeStyle({
          height: _ctx.footerVisible ? '6%' : '7%',
        })
              }, [
                _createElementVNode("button", {
                  disabled: _ctx.adsibEnabled && _ctx.disabledButtonLegalComputed,
                  class: "pdf-button",
                  onClick: _cache[2] || (_cache[2] = () => _ctx.onModal(true))
                }, " FIRMAR ", 8, _hoisted_21)
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.valorLegal.agetic && _ctx.signature.agetic)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "sidebar-footer",
                style: _normalizeStyle({
          height: _ctx.footerVisible ? '6%' : '7%',
        })
              }, [
                (_ctx.valorLegal.agetic && _ctx.ciudadaniaDigital)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      title: "Click para Aprobar",
                      disabled: _ctx.disabledButtonLegalComputed,
                      class: "pdf-button",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onAprobarCiudadania && _ctx.onAprobarCiudadania(...args)))
                    }, " APROBAR ", 8, _hoisted_22))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "pdf-button",
                      disabled: _ctx.disabledButtonLegalComputed,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onLoginCiudadaniaDigital && _ctx.onLoginCiudadaniaDigital(...args))),
                      title: "Click para Iniciar Sesión"
                    }, " INICIAR SESIÓN ", 8, _hoisted_23))
              ], 4))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.modalFirma)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("form", _hoisted_25, [
            _createElementVNode("span", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onModal(false))),
              class: "close",
              title: "Cerrar Modal"
            }, "×"),
            _createElementVNode("div", _hoisted_26, [
              _cache[22] || (_cache[22] = _createElementVNode("p", { class: "pdf-model-title" }, "Firmar Documentos", -1)),
              _createElementVNode("p", _hoisted_27, " ¿Esta seguro que desea firmar los documentos(" + _toDisplayString(_ctx.$props.files.length) + ")? ", 1),
              _createElementVNode("div", _hoisted_28, [
                _cache[21] || (_cache[21] = _createElementVNode("div", {
                  for: "form_password",
                  class: "pdf-label"
                }, "Pin:", -1)),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    id: "form_password",
                    type: _ctx.passwordVisible ? 'text' : 'password',
                    class: "pdf-input-text",
                    placeholder: "Introduzca su pin",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pin) = $event))
                  }, null, 8, _hoisted_30), [
                    [_vModelDynamic, _ctx.pin]
                  ]),
                  (!_ctx.passwordVisible)
                    ? (_openBlock(), _createBlock(_component_EyeIcon, {
                        key: 0,
                        class: "pdf-input-icon",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.passwordVisible = !_ctx.passwordVisible))
                      }))
                    : (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                        key: 1,
                        class: "pdf-input-icon",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.passwordVisible = !_ctx.passwordVisible))
                      }))
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  type: "button",
                  class: "pdf-btn-cancel",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onModal(false)))
                }, " Cancelar "),
                _createElementVNode("button", {
                  type: "button",
                  class: "pdf-btn-ok",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onFirmar && _ctx.onFirmar(...args))),
                  disabled: _ctx.pin.length < 5
                }, " Aceptar ", 8, _hoisted_32)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalSync)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("form", _hoisted_34, [
            _createElementVNode("span", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.modalSync = false)),
              class: "close",
              title: "Cerrar Modal"
            }, "×"),
            _createElementVNode("div", _hoisted_35, [
              _cache[23] || (_cache[23] = _createElementVNode("p", { class: "pdf-model-title" }, "Sincronizar Documento", -1)),
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "pdf-model-subtitle" }, [
                _createTextVNode(" ¿Esta seguro que desea sincronizar "),
                _createElementVNode("br"),
                _createTextVNode(" las firmas y aprobaciones del documento? ")
              ], -1)),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  type: "button",
                  class: "pdf-btn-cancel",
                  onClick: _cache[12] || (_cache[12] = () => (_ctx.modalSync = false))
                }, " Cancelar "),
                _createElementVNode("button", {
                  type: "button",
                  class: "pdf-btn-ok",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onSyncFile && _ctx.onSyncFile(...args))),
                  onKeyup: _cache[14] || (_cache[14] = _withKeys(() => _ctx.onSyncFile(), ["enter"]))
                }, " Aceptar ", 32)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}